import { NavLink } from 'react-router';

/** A sidebar link (Shell.jsx, AdminSidebar.jsx); the page on screen is highlighted. */
export function NavItem({ to, children, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `block rounded-md px-3 py-1.5 text-sm transition-colors ${isActive ? 'bg-ink-soft font-semibold text-white' : 'text-white/70 hover:text-white'}`
      }
    >
      {children}
    </NavLink>
  );
}
